<fab-loading-spinner *ngIf="isPageLoading"></fab-loading-spinner>
<mat-dialog-content>
    <div class="modal-container">
        <h1>Absence Request</h1>
        <form fxLayout="column" fxLayoutAlign="center" (ngSubmit)="submitForm()" #form="ngForm">
            <table>
                <tr>
                    <th id="country">Work Abroad Country Selection:</th>
                    <td>
                        <div fxLayout="row wrap" fxLayoutGap="12px">
                            <mat-form-field appearance="outline" class="section-size">
                                <mat-label>Please select a Region</mat-label>
                                <mat-select id="vacationType" name="vacationType" [(ngModel)]="model.country"
                                            #countrySelection required>
                                    <mat-select-filter *ngIf="countrySelection.focused" [array]="countryNameArray"
                                                       (filteredReturn)="countryNameArray2 = $event"></mat-select-filter>
                                    <mat-option *ngFor="let country of countryNameArray2" [value]="country">
                                        {{country}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <mat-card class="days-card section-size mat-elevation-z0">
                                <div fxLayout="column">
                                    <div><strong>Work Abroad
                                        Days:</strong>{{isEditing ? numDaysAbroad : model.numberOfWorkAbroadDays}}</div>
                                    <div><strong>Vacation
                                        Days:</strong>{{isEditing ? vacationDays : daysSelected.length + preApprovedVacations.length}}
                                    </div>
                                </div>
                            </mat-card>
                        </div>
                    </td>
                </tr>
                <tr *ngIf="this.employee.employeeWorkAbroadAllowance.length !== 0">
                    <th id="half-day">Is request for next rolling period?:</th>
                    <td class="inline-block padding">
                        <mat-checkbox id="nextYearTrip" name="nextYearTrip" (click)="forNextYear()"
                                      [(ngModel)]="notForNextYearWork"></mat-checkbox>
                    </td>
                </tr>
            </table>
            <div *ngIf="this.employee.employeeWorkAbroadAllowance.length !== 0">
                <p class="next-rolling-period-note"> Note: This is referring to the next rolling period, which is 12
                    months following your first request</p>
            </div>
            <table>
                <tr>
                    <th id="dates">Select Dates of Work Abroad Trip:</th>
                    <td>
                        <div fxLayout="row wrap" fxLayoutGap="12px">
                            <mat-form-field class="WorkAbroadForm" appearance="outline">
                                <mat-label>{{formattedStartDate && formattedEndDate ? formattedStartDate + ' - ' + formattedEndDate : 'Work Abroad Dates'}}</mat-label>
                                <mat-date-range-input
                                        [formGroup]="startEndRange"
                                        [rangePicker]="picker" [dateFilter]="makeWeekendUnselectable"
                                        [min]="minWorkAbroadDate" [max]="maxWorkAbroadDate" disabled required>
                                    <input matStartDate placeholder="Start date" formControlName="start"
                                           #dateRangeStart/>
                                    <input matEndDate placeholder="End date" formControlName="end" #dateRangeEnd/>
                                </mat-date-range-input>
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
                                <mat-date-range-picker #picker disabled="false"
                                                       (opened)="this.isDuplicated=false"
                                                       (closed)="changeAvailableVacationRange(dateRangeStart.value, dateRangeEnd.value)"></mat-date-range-picker>
                            </mat-form-field>

                            <button mat-stroked-button class="vacation-button" type="button" (click)="onMatMenuOpen()"
                                    [matMenuTriggerFor]="appMenu">
                                <div fxLayout="column"></div>
                                <h4>Vacation Days</h4>
                                <mat-icon class="calendarIcon">calendar_today</mat-icon>
                            </button>
                            <mat-menu #appMenu="matMenu" class="inline-calendar-card">
                                <div (click)="$event.stopPropagation()">
                                    <mat-calendar #calendar (selectedChange)="select($event,calendar)"
                                                  [dateClass]="isSelected"
                                                  [dateFilter]="makePublicHolidayUnselectable"
                                                  [minDate]="request=== null ? minWorkAbroadVacationDate : minWorkAbroadEditVacationDate"
                                                  [maxDate]="request=== null ? maxWorkAbroadVacationDate : maxWorkAbroadEditVacationDate"
                                                  (click)="removePublicHolidaySelected()">
                                    </mat-calendar>
                                </div>
                            </mat-menu>
                        </div>
                    </td>
                </tr>
            </table>

            <div class="dropDown">
                <em class="fa sort-icon pull-right" [ngClass]="expandDialogIcon(expandDialog)"></em>
                <strong (click)="hasClickedTermsAndConditions()">View Remote Working Terms & Conditions</strong>
            </div>
            <div class="termsAndConditions">
                <div class="termsAndConditionsExpand" *ngIf="expandDialog == true">
                    <h2 mat-dialog-title>Terms & Conditions for Working Across International Borders Policy</h2>
                    <strong>GM Policy – Working Across International Borders Policy. </strong>
                    <br/>
                    <ul>
                        <li><em>• Employees can work remote in another country for up to 40 working days in any 12
                            months rolling period, but no more than 20 working days per trip. A significant break is
                            required between the trips i.e. see table below.</em></li>
                        <li><em>Employees can extend their trip by utilizing vacation</em></li>
                    </ul>
                    <strong>NOTE: </strong> Please ensure to update the HR Vacation Tracker with any planned vacation
                    leave during this trip and ensure you have entered the annual leave days required for Christmas Shut
                    Down Period
                    <br/>
                    <br/>
                    <strong>Breakdown of Significant Break between Work Abroad requests</strong>
                    <table class="breakBreakdown">
                        <tr>
                            <th id="days">Days Working Abroad</th>
                            <th id="break">Break Required</th>
                        </tr>
                        <tr>
                            <td id="1-10">1-10 Days Working Abroad</td>
                            <td>1 Month Break Required</td>
                        </tr>
                        <tr>
                            <td id="1-15">11-15 Days Working Abroad</td>
                            <td>2 Months Break Required</td>
                        </tr>
                        <tr>
                            <td id="16-20">16-20 Days Working Abroad</td>
                            <td>3 Months Break Required</td>
                        </tr>
                    </table>
                    <br/>
                    <strong>Terms & Conditions of Working Across International Borders</strong>
                    <br/>
                    <em>Your request to Work Abroad outside of Republic of Ireland has been reviewed in line with
                        information you have provided and is approved with the following Terms & Conditions:</em>
                    <ul>
                        <li>Your place of work will remain unchanged as per your Contract of Employment and your
                            salary will continue to be paid and taxed in Republic of Ireland.
                        </li>
                        <li>You will be required to work your normal hours in line with the time zone of the Republic of
                            Ireland and your terms and conditions of employment remain unchanged.
                        </li>
                        <li>Expectations of performance and behaviours will remain unchanged.
                        </li>
                        <li>You are not permitted to sign any contracts on behalf of GM while working outside the
                            Republic of Ireland. If this is likely to be a requirement, please consult with your Manager
                            and HR.
                        </li>
                        <li>You are personally liable for completing any appropriate tax declarations and are
                            responsible for any additional income taxes and/or employee social security. which may arise
                            due to working outside of the Republic of Ireland. If required, the company will make
                            additional payroll deductions or seek reimbursements from you.
                        </li>
                        <li>You are responsible to ensure all relevant immigration documents relating to working and
                            residing in Republic of Ireland are up to date and will not expire while working outside of
                            Republic of Ireland.
                        </li>
                        <li>Please ensure you undertake the necessary investigations and advice to ensure your travel
                            and any period of working outside of the Republic of Ireland will not impact your residency,
                            visa and right to work in the Republic of Ireland in the future. Please pay particular
                            attention to the rule requiring 21 months continuous employment in the State.
                        </li>
                        <li>You are personally responsible for all immigration expenses.
                        </li>
                        <li>Days of travel must be recorded and taken as vacation, if travel occurs during the working
                            week.
                        </li>
                        <li>In the event the company requests that you return to the Republic of Ireland to attend work
                            at your contracted work location and/or any other location, you will be required to return
                            as requested.
                        </li>
                        <li>If you are unable to work due to lack of IT connectivity, (outside of the GM IT
                            infrastructure) you will be required to record and take this time as vacation.
                        </li>
                        <li>In the event you are unable to work due to a failure of IT Equipment, which cannot be
                            resolved at the remote location, the company reserves the right to request that you return
                            to the Republic of Ireland as soon as possible.
                        </li>
                        <li>Working Abroad outside of terms of this approval, will be considered as Working Across
                            International Borders without Approval and may result in Disciplinary Action.
                        </li>
                        <li>No extension will be granted over 20 days working abroad in any trip- you will be required
                            to use your annual leave as the period of working abroad cannot be extended as per the
                            Working Across International Borders Policy and you need to return to Republic of Ireland in
                            line with the original planned return date.
                        </li>
                        <li>If flights are changed/cancelled you will need to explore alternative flight arrangement
                            to return back by this date.
                        </li>
                        <li>If requested by the company, you will provide details of travel/flight bookings to support
                            this approved Working Across International Borders request.
                        </li>
                        <li>On your return back to the Republic of Ireland you, are required to confirm your return to
                            work with you manager and CC HR Queries Mailbox.
                        </li>
                        <li>As such if there is <em>any change to the information you have provided</em>, then you must
                            advise your manager & HR immediately & also update you Remote Working Information.
                        </li>
                        <li>Sick leave while working abroad does not allow for additional time out of country and you
                            need to return to Republic of Ireland in line with the original planned return date. The
                            normal sick leave policy & process also applies and illness benefit will be deducted if
                            applicable.
                        </li>
                        <li>Planned medical procedures need to be recorded as sick leave and sick leave while working
                            abroad does not allow for additional time out of country and you need to return to Republic
                            of Ireland in line with the original planned return date. The normal sick leave policy &
                            process also applies and illness benefit will be deducted if applicable. You also must
                            notify HR in advance that you are planning to have a medical procedure while abroad so there
                            is awareness of the sick leave in advance to help with work planning.
                        </li>
                        <li>
                            The company reserves the right to request that employees provide a medical certificate
                            from an Ireland registered GP.
                        </li>
                        <li>The Company reserves the right to audit Requests to Work Across International borders. As
                            part of this audit, the Company may request documentation related to the return travel to
                            Ireland on or before the approved date i.e airline ticket.
                        </li>
                        <li>GM policy prohibits business travel to or working remotely from certain countries.
                            More info on listed countries is available <a href="https://gmweb.gm.com/legal/Legal/Pages/OEC_embargoed.aspx">here</a>.
                            If a country is added to the list while working abroad,
                            employees will be required to take vacation and return back to the Republic of Ireland.
                        </li>
                        <li>The company reserves the right to withdraw this approval.</li>
                    </ul>
                    <br/>
                    <strong>Working Across International Borders FAQ’s:</strong>
                    <br/>
                    <strong>Q: </strong>Can I do consecutive 40 working days?
                    <br/>
                    <strong>A: </strong>No, trips are limited to 20 working days per trip. But the trip can be made up
                    of i.e. 20 working days and annual leave
                    <br/>
                    <br/>
                    <strong>Q: </strong>What if I take another trip in the 12-month rolling year?
                    <br/>
                    <strong>A: </strong>Must be distinctively separate trips with several months spent back working in
                    the Republic of Ireland.
                    <br/>
                    <br/>
                    <strong>Q: </strong>Is the 12 months period aligned with calendar year?
                    <br/>
                    <strong>A: </strong>No, the 12 months period aligns with first day of the first trip of working
                    abroad.
                    <br/>
                    <br/>
                    <strong>Q: </strong>Can I work 20 days, take vacation and then work another 20 days?
                    <br/>
                    <strong>A: </strong>No, per each trip only 20 working days. Must be distinctively separate trips
                    with a break in the home country as outlined in the below table:
                    <br/>
                    <br/>
                    <strong>Breakdown of Significant Break between Work Abroad requests</strong>
                    <table class="breakBreakdown">
                        <tr>
                            <th id="days">Days Working Abroad</th>
                            <th id="break">Break Required</th>
                        </tr>
                        <tr>
                            <td id="1-10">1-10 Days Working Abroad</td>
                            <td>1 Month Break Required</td>
                        </tr>
                        <tr>
                            <td id="1-15">11-15 Days Working Abroad</td>
                            <td>2 Months Break Required</td>
                        </tr>
                        <tr>
                            <td id="16-20">16-20 Days Working Abroad</td>
                            <td>3 Months Break Required</td>
                        </tr>
                    </table>
                    <br/>
                    <br/>
                    <strong>Q: </strong>If I fall sick while working abroad, how are those days treated? E.g. Can my
                    trip be extended by the number of days I am ill?
                    <br/>
                    <strong>A: </strong>Sick leave while working abroad does not allow for additional time out of
                    country and you need to return to Republic of Ireland in line with the original planned return date.
                    The normal sick leave policy & process also applies and illness benefit will be deducted if
                    applicable.
                    <br/>
                    <br/>
                    <strong>Q: </strong>I am planning a medical procedure while abroad, can I still get 20 working days
                    in addition to the planned medical leave?
                    <br/>
                    <strong>A: </strong>Planned medical procedures will be recorded as sick leave and sick leave while
                    working abroad does not allow for additional time out of country and you need to return to Republic
                    of Ireland in line with the original planned return date. The normal sick leave policy & process
                    also applies and illness benefit will be deducted if applicable. You also must notify HR in advance
                    that you are planning to have a medical procedure while abroad so there is awareness of the sick
                    leave in advance to help with work planning.
                    <br/>
                    <br/>
                    <strong>By ticking the box below, I confirm,</strong>
                    <ul>
                        <li>I have read and agree to the Terms & Conditions outline above</li>
                        <li>All vacation(s) have been recorded in the Absence Tracker</li>
                    </ul>
                    <br/>
                    <strong>We wish you a safe and enjoyable trip.</strong>
                    <br/>
                    <strong>HR Team</strong>
                </div>
            </div>
            <table>
                <tr>
                    <th id="text">I have read and agree to the Terms & Conditions outline above</th>
                    <td>
                        <mat-checkbox id="Terms" name="Terms" (change)="checkboxChange('terms', $event)"></mat-checkbox>
                    </td>
                </tr>
                <tr>
                    <th id="text2">All vacation(s) have been recorded in the Absence Tracker</th>
                    <td>
                        <mat-checkbox id="Recording" name="Recording"
                                      (change)="checkboxChange('recording', $event)"></mat-checkbox>
                    </td>
                </tr>
            </table>
            <br/>
            <button mat-raised-button color="primary"
                    [disabled]="!form.form.valid || !checkWorkAbroadAllowance() || !checkHolidayAllowance() || startEndRange.value.start == null || startEndRange.value.end == null || !terms || !recording">
                Submit
            </button>
        </form>
    </div>
</mat-dialog-content>
